import { VFileInput } from 'vuetify/lib/components/VFileInput';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFileInput,{attrs:{"truncate-length":"30","show-size":"","label":_vm.itemAction.name,"outlined":"","dense":""},on:{"change":_vm.selectFile}})}
var staticRenderFns = []

export { render, staticRenderFns }